import { authority } from '@/utils'
import axios from 'axios'

export const xAuthToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ3b3Jrc3BhY2VfaWQiOiJlM2RlYTBmNS0zN2YyLTRkNzktYWU1OC00OTBhZjMyMjgwNjkiLCJzdWIiOiJDbG91ZEFwaVNhbXBsZSIsInVzZXJfdHlwZSI6IjEiLCJuYmYiOjE2NTcxODUzODIsImxvZyI6IkxvZ2dlcltjb20uc2hpbmUuY2hlcnJ5LnNlcnZpY2UuZmxpZ2h0LmNvbnRyb2wuY29tbW9uLm1vZGVsLkN1c3RvbUNsYWltXSIsImlzcyI6IkRKSSIsImlkIjoiYTE1NTllN2MtOGRkOC00NzgwLWI5NTItMTAwY2M0Nzk3ZGEyIiwiZXhwIjo0ODEwNzg1MzgyLCJpYXQiOjE2NTcxODUzODIsInVzZXJuYW1lIjoiYWRtaW5QQyJ9.JgMzKSoPQxs4d9mlAE1Ms42VgTr60pDwa8hBqvD0tmM'

export function getProblemList() {
  return axios.get('/dispatch1/dispatch/task/problem/list')
}

export function getProblemDetails(problemId:string|number) {
  return axios.get('/dispatch1/dispatch/task/problem', {
    params: {
      problemId,
    },
  })
}

export function confirmProblemList(problemIds:Array<number|string>) {
  return axios.put('/dispatch1/dispatch/task/problem/confirm', {
    problemIds,
  })
}

// 获取远程点位
export function getElementGroups(ids:Array<number>) {
  // return axios.get('fcontrol1/dj-http-api/map/api/v1/workspaces/element-groups', {
  //   params: {
  //     taskIds: ids.join(','),
  //   },
  //   headers: {
  //     'x-auth-token': xAuthToken,
  //   },
  // })
  const { djToken, workspaceId, groupId } = authority()
  return axios.get(`fcontrol1/dj-http-api/map/api/v1/workspaces/${workspaceId}/element-groups`, {
    headers: {
      'x-auth-token': djToken,
    },
    params: {
      taskIds: ids.join(','),
    },
  })
}
// 新增远程点位
export function addElementGroups(data:any) {
  // return axios.post('fcontrol1/map/api/v1/workspaces/elements/save', {
  //   ...data,
  // }, {
  //   headers: {
  //     'x-auth-token': xAuthToken,
  //   },
  // })
  const { djToken, workspaceId, groupId } = authority()
  return axios.post(`fcontrol1/dj-http-api/map/api/v1/workspaces/${workspaceId}/element-groups/${groupId}/elements`, {
    ...data,
  }, {
    headers: {
      'x-auth-token': djToken,
    },
  })
}
// 修改远程点位
export function editElementGroups(id:string, data:any) {
  // return axios.put(`fcontrol1/map/api/v1/workspaces/elements/${id}`, {
  //   ...data,
  // }, {
  //   headers: {
  //     'x-auth-token': xAuthToken,
  //   },
  // })
  const { djToken, workspaceId, groupId } = authority()
  return axios.put(`fcontrol1/dj-http-api/map/api/v1/workspaces/${workspaceId}/elements/${id}`, {
    ...data,
  }, {
    headers: {
      'x-auth-token': djToken,
    },
  })
}
// 删除远程点位
export function delElementGroups(id:string, deviceSn:string) {
  // return axios.delete(`fcontrol1/map/api/v1/workspaces/elements/${id}/${deviceSn}`, {
  //   headers: {
  //     'x-auth-token': xAuthToken,
  //   },
  // })
  const { djToken, workspaceId, groupId } = authority()
  return axios.delete(`fcontrol1/dj-http-api/map/api/v1/workspaces/${workspaceId}/elements/${id}`, {
    headers: {
      'x-auth-token': djToken,
    },
  })
}

/**
 * 打开一个直播源
 * @param {string} deviceSn
 */
// eslint-disable-next-line camelcase
export function openLive(videoId:any) {
  const { djToken } = authority()
  return axios.post('fcontrol1/dj-http-api/manage/api/v1/live/streams/start', {
    url: '',
    url_type: 1, // "0":"声网Agora","1":"RTMP","2":"RTSP","3":"GB28181"
    video_quality: 0, // "0":"自适应","1":"流畅","2":"标清","3":"高清","4":"超清"
    video_type: 'normal', // "normal":"默认","wide":"广角","zoom":"变焦","ir":"红外"
    video_id: videoId,
  }, {
    headers: {
      'x-auth-token': djToken,
    },
  })
}

// 切换知眸ai识别
// eslint-disable-next-line camelcase
export function aiLive(data:any) {
  return axios.post('dispatch1/zhi-mou/start/live', {
    ...data,
  })
}
